import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const CommandSchema = withDefaults({
  type: 'command',
  objectExtensions: ['command'],
  fields: [
    {
      kind: 'attribute',
      name: 'command',
    },
    {
      kind: 'attribute',
      name: 'status',
    },
    {
      kind: 'attribute',
      name: 'message',
    },
    {
      kind: 'attribute',
      name: 'result',
    },
    {
      kind: 'attribute',
      name: 'commandErrors',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
  ],
});

export default CommandSchema;
